import { intersectionBy as _intersectionBy, uniq as _uniq } from 'lodash';
import type { datetime, DeliveryBlock } from '@bringg/types';
import moment from 'moment';

import type { RoutesPlannerRun } from '../../../types';

const isTimeFramesOverlap = (deliveryBlockTimeRange: datetime[], timeWindow: datetime[]) => {
	const timeWindowValues = _uniq(timeWindow);
	if (timeWindowValues.length === 1) {
		return moment(timeWindowValues[0]).isBetween(
			moment(deliveryBlockTimeRange[0]),
			moment(deliveryBlockTimeRange[1])
		);
	}
	return (
		moment.max(moment(deliveryBlockTimeRange[0]), moment(timeWindow[0])) <
		moment.min(moment(deliveryBlockTimeRange[1]), moment(timeWindow[1]))
	);
};

const filterByDatesDeliveryBlocks = (deliveryBlocks, startDate, endDate, canSetTasksPastDeliveryBlock = false) =>
	deliveryBlocks?.filter(
		deliveryBlock =>
			isTimeFramesOverlap([deliveryBlock.start_time, deliveryBlock.end_time], [startDate, endDate]) ||
			(canSetTasksPastDeliveryBlock &&
				moment(deliveryBlock.start_time).startOf('minute').toISOString() <= startDate)
	);

export const getResourceDeliveryBlocks = (
	run: RoutesPlannerRun,
	deliveryBlocksByDriver: { [userId: number]: DeliveryBlock[] },
	deliveryBlocksByVehicle: { [vehicleId: number]: DeliveryBlock[] },
	startDate?: string,
	endDate?: string,
	canSetTasksPastDeliveryBlock?: boolean
): DeliveryBlock[] => {
	let deliveryBlocks = [];
	const vehicleId = deliveryBlocksByVehicle && run.vehicle_id;
	if (run.user_id && vehicleId) {
		deliveryBlocks = _intersectionBy(deliveryBlocksByDriver[run.user_id], deliveryBlocksByVehicle[vehicleId], 'id');
		deliveryBlocks =
			startDate && endDate
				? filterByDatesDeliveryBlocks(deliveryBlocks, startDate, endDate, canSetTasksPastDeliveryBlock)
				: deliveryBlocks;
	}
	if (vehicleId && !deliveryBlocks.length) {
		deliveryBlocks =
			startDate && endDate
				? filterByDatesDeliveryBlocks(
						deliveryBlocksByVehicle[vehicleId],
						startDate,
						endDate,
						canSetTasksPastDeliveryBlock
				  )
				: deliveryBlocksByVehicle[vehicleId];
	}
	if (run.user_id && !deliveryBlocks?.length) {
		deliveryBlocks =
			startDate && endDate
				? filterByDatesDeliveryBlocks(
						deliveryBlocksByDriver[run.user_id],
						startDate,
						endDate,
						canSetTasksPastDeliveryBlock
				  )
				: deliveryBlocksByDriver[run.user_id];
	}
	return deliveryBlocks || [];
};
